import { sleep } from "src/mentor/helpers/utilityFunctions"

export const createBookingPayload = ({
  mentorProfile,
  currentEventTypeObject,
  selectedSlot,
  selectedPatient,
  bookingFormData,
  currentBookedEventId,
}) => ({
  isUsingClinicAppointmentType: false,
  mentorId: mentorProfile?.id,
  eventTypeId: currentEventTypeObject?.uid || currentEventTypeObject?.id,
  eventType: currentEventTypeObject?.type,
  subscriptionPlanId:
    currentEventTypeObject?.pricingPlanId || currentEventTypeObject?.subscriptionPlanId,
  startTimeInDayJs: selectedSlot.start,
  eventMode: currentEventTypeObject?.meetingSrc === 'online' ? 'online' : 'offline',
  eventDurationInMins: currentEventTypeObject?.durationInMins,
  patientId: selectedPatient?.id,
  clinicId: selectedPatient?.clinicId,
  clinicBrandId: selectedPatient?.clinicBrandId,
  paymentGateway: 'paymentLinkInitiatedByMentor',
  feeCurrency: bookingFormData?.currency || 'inr',
  bookScreeningAutomatically: false,
  notScreeningReason: {
    id: '',
    title: '',
  },
  sendLinkToPatient: true,
  sendLinkToRelative: false,
  customPhonesToSendLinkTo: [],
  eventFee: bookingFormData?.fee,
  feePaymentMode: 'aumhum',
  feePaidTxnId: '',
  triggeringBookedEventId: currentBookedEventId,
})

export const handleBookingSuccess = async ({
  onSlotSelect,
  selectedSlot,
  selectedDate,
  refreshData,
  saveReport,
  handleClose,
}) => {
  if (onSlotSelect) {
    onSlotSelect({
      startTime: selectedSlot.start.toISOString(),
      endTime: selectedSlot.end.toISOString(),
      selectedDate: selectedDate,
      timeSlot: selectedSlot.label,
    })
  }

  if (saveReport) await saveReport()
  await sleep(1000)
  if (refreshData) await refreshData()

  handleClose(true)
}
